<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Bulk Upload Report</legend>
            <!--Grid row-->
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label="From Date:" label-for="input-1">
                        <datepicker v-model="fromDate" input-class="form-control" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-button type="button" @click="getReport" variant="primary">
                        Retrieve Report
                    </b-button>
                </b-col>
            </b-row>
            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields">
                        <template #cell(createdOn)="data">
                            <span>{{data.item.createdOn | formateDate}}</span>
                        </template>
                        <template #cell(updatedOn)="data">
                            <span>{{data.item.updatedOn | formateDate}}</span>
                        </template>
                        <template #cell(id)="data">
                            <span>
                                <router-link :to="{ path: '/bulktransactionsreport', query: { b: data.item.id, d: data.item.description }}">
                                    <b-button type="button" pill variant="outline-secondary">
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                    
                                </router-link>
                                </span>
                        </template>
                    </b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination> total Records {{totalRecords}}
                </div>
            </div>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>